module.exports = __webpack_public_path__ + "img/empty-layer-background.41398e42.svg";